import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { logout } from '../store/thunks/authThunks';
import { toggleSidebar, toggleDarkMode } from '../store/slices/uiSlice';
import { BellIcon, MoonIcon, SunIcon, MenuIcon, UserCircleIcon } from '@heroicons/react/outline';

const Navbar = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { user } = useSelector(state => state.auth);
    const { darkMode } = useSelector(state => state.ui);
    const [dropdownOpen, setDropdownOpen] = useState(false);
  
    const handleLogout = () => {
      dispatch(logout());
      navigate('/login');
    };

    const showProfile = ()=>{
      setDropdownOpen(false);
      navigate('/user/profile');
    }
  
    return (
      <nav className="bg-white dark:bg-gray-800 shadow-md">
        <div className="px-4 py-3 md:px-6">
          <div className="flex items-center justify-between">
            <div className="flex items-center">
              <button 
                className="text-gray-600 dark:text-gray-200 focus:outline-none mr-4 md:hidden"
                onClick={() => dispatch(toggleSidebar())}
              >
                <MenuIcon className="h-6 w-6" />
              </button>
              <h1 className="text-lg md:text-xl font-semibold text-gray-800 dark:text-white">School Admin Panel</h1>
            </div>
            
            <div className="flex items-center space-x-4">
              <div className="relative">
                <button 
                  className="flex items-center text-gray-600 dark:text-gray-200 focus:outline-none cursor-pointer"
                  onClick={() => setDropdownOpen(!dropdownOpen)}
                >
                  <UserCircleIcon className="h-8 w-8 mr-1" />
                  <span className="hidden md:block">{user?.name || 'User'}</span>
                </button>
                
                {dropdownOpen && (
                  <div className="absolute right-0 mt-2 w-48 bg-white dark:bg-gray-800 rounded-md shadow-lg py-1 z-10">
                    <button
                      className="block w-full text-left px-4 py-2 text-sm text-gray-700 dark:text-gray-200 hover:bg-gray-100 dark:hover:bg-gray-700 cursor-pointer"
                      onClick={showProfile}
                    >
                      Profile
                    </button>
                    <button
                      className="block w-full text-left px-4 py-2 text-sm text-gray-700 dark:text-gray-200 hover:bg-gray-100 dark:hover:bg-gray-700 cursor-pointer"
                      onClick={handleLogout}
                    >
                      Logout
                    </button>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </nav>
    );
}

export default Navbar
